import { render, staticRenderFns } from "./WarnTips.vue?vue&type=template&id=23597648&scoped=true&"
import script from "./WarnTips.vue?vue&type=script&lang=js&"
export * from "./WarnTips.vue?vue&type=script&lang=js&"
import style0 from "./WarnTips.vue?vue&type=style&index=0&id=23597648&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23597648",
  null
  
)

export default component.exports